/**
 * @Author: Nenad Brcic
 * @Date: 27.05.16
 * @Email: neno@neno.ch
 */

import settings from '../config/settings';

let vitraLocalData = {};

export function resetSearchFields() {
    const fields = [settings.search.fields.simple].concat(settings.search.fields.advanced);
    fields.map((f) => vitraLocalData.search[f] = null);
}

export function initLocalStorage() {
    vitraLocalData = {};
    vitraLocalData.search = {};
    vitraLocalData.visitStartedAt = new Date();
    clearMyCollection();
}

export function resetLocalData() {
    initLocalStorage();
}

export function setLanguage(lang) {
    vitraLocalData.lang = lang;
}

export function getCurrentLanguage() {
    return vitraLocalData.lang;
}

export function setSimpleSearch(s) {
    resetSearchFields();
    vitraLocalData.search.searchQuery = s;
}

export function setAdvancedSearch(searchObj) {
    vitraLocalData.search = searchObj;
}

export function getSearchFields() {
    return vitraLocalData.search;
}

export function getMyCollection() {
    return vitraLocalData.myCollection;
}

export function addToMyCollection(group, id) {
    if (vitraLocalData.myCollection[group].indexOf(id) === -1) {
        vitraLocalData.myCollection[group].push(id);
    }
}

export function removeFromMyCollection(group, id) {
    const idx = vitraLocalData.myCollection[group].indexOf(id);
    if (idx > -1) {
        vitraLocalData.myCollection[group].splice(idx, 1);
    }
}

export function clearMyCollection() {
    vitraLocalData.myCollection = {};
    vitraLocalData.myCollection.objects = [];
    vitraLocalData.myCollection.designers = [];
    vitraLocalData.myCollection.producers = [];
}

export function isMyCollectionEmpty() {
    return (
        !vitraLocalData.myCollection.objects.length
        && !vitraLocalData.myCollection.designers.length
        && !vitraLocalData.myCollection.producers.length
    );
}

export function isNavigationActive() {
    return vitraLocalData.isNavigationActive;
}

export function activateNavigation() {
    return vitraLocalData.isNavigationActive = true;
}

export function deActivateNavigation() {
    return vitraLocalData.isNavigationActive = false;
}

export function toggleIsNavigationActive() {
    return vitraLocalData.isNavigationActive = !vitraLocalData.isNavigationActive;
}

export function deActivateSplashScreen() {
    vitraLocalData.showSplashScreen = false;
}

export function setIsForKids(flag) {
    vitraLocalData.isForKids = flag;
}

export function showTextForKids() {
    return !!vitraLocalData.isForKids;
}



// WEBPACK FOOTER //
// ./app/localData.js